import RosRiverMapComponent from '../../components/MapComponent/RosRiverMapComponent.';
import SideBarComponent from '../../components/SideBarComponent/SideBarComponent';
import './DasboardPage.scss';
import { Feature } from "geojson";
import {useState} from 'react';
import MapFeatureDetailsComponent from '../../components/MapFeatureDetailsComponent/MapFeatureDetailsComponent';
import {FEATURE_DETAILS_COMPONENT, FEATURE_DETAILS_COMPONETN_TYPES} from '../../shared/enums';
import MapFeatureMonitoringDetailsComponent from '../../components/MapFeatureMonitoringDetailsComponent/MapFeatureMonitoringDetailsComponent';

function DashboardPage() {

    const [selectedFeature, setSelectedFeature] = useState<Feature | null>(null);
    const [selectedLayer, setSelectedLayer] = useState<string>("");
    const [isMapFeatureDetailsOpen, setIsMapFeatureDetailsOpen] = useState<boolean>(false);
    const [isMapFeatureMonitoringDetailsOpen, setIsMapFeatureMonitoringDetailsOpen] = useState<boolean>(false);

    const onEachMapFeatureClickHandler = (feature: Feature, layerName: string) => {
        if (!feature.properties) return;
        const detailsComponent = FEATURE_DETAILS_COMPONENT[layerName];
        switch (detailsComponent) {
            case FEATURE_DETAILS_COMPONETN_TYPES.DEFAULT:
                setIsMapFeatureMonitoringDetailsOpen(false);
                setIsMapFeatureDetailsOpen(true)
                break;
            case FEATURE_DETAILS_COMPONETN_TYPES.MONITORING:
                setIsMapFeatureDetailsOpen(false);
                setIsMapFeatureMonitoringDetailsOpen(true);
                break;
            default:
                break;
        }
        setSelectedFeature(feature)
        setSelectedLayer(layerName)
    };

    return (
        <div className="container">
            <SideBarComponent />
            <div className="content">
                <RosRiverMapComponent onEachFeature={onEachMapFeatureClickHandler} />
                <MapFeatureDetailsComponent
                    feature={selectedFeature}
                    layerName={selectedLayer}
                    isActive={isMapFeatureDetailsOpen}
                    onClose={() => setIsMapFeatureDetailsOpen(false)}
                />
                <MapFeatureMonitoringDetailsComponent
                    feature={selectedFeature}
                    layerName={selectedLayer}
                    isActive={isMapFeatureMonitoringDetailsOpen}
                    onClose={() => setIsMapFeatureMonitoringDetailsOpen(false)}
                />
            </div>
        </div>
    );
}

export default DashboardPage;
